import { render, staticRenderFns } from "./KoiskUserDashboard.vue?vue&type=template&id=a9280ab2"
import script from "./KoiskUserDashboard.vue?vue&type=script&lang=js"
export * from "./KoiskUserDashboard.vue?vue&type=script&lang=js"
import style0 from "./KoiskUserDashboard.vue?vue&type=style&index=0&id=a9280ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports